import axios from 'axios';
import Cookies from 'js-cookie';
import { stringEnum } from '@/constant/string';
import liff from '@line/liff';

export const getProfileFromLine = async (accessToken) => {
    const accessTokenResponse = await axios.get(
        'https://api.line.me/oauth2/v2.1/verify',
        { params: { access_token: accessToken } }
    );
    if (accessTokenResponse.status !== 200) return null;
    const profileResponse = await axios.get('https://api.line.me/oauth2/v2.1/profile', {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
    const profile = JSON.stringify(profileResponse.data);

    Cookies.set(stringEnum.storeUser, profile);

    return profileResponse.data;
};

export const getIdToken = () => {
    return liff.getIDToken();
};
